import gql from "graphql-tag";

export const GET_PRODUCT_GROUP = gql`
  query productGroup($id: ID!) {
    productGroup(id: $id) {
      id
      name
      description,
      fullPathName
      parentGroup {
        id
        fullPathName
      }
    }
  },
`;
